module.exports = __webpack_public_path__ + "img/video.5d41b6b1.svg";